import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import React from "react";
import useRefForContext from "../utils/useRefForContext.js";
var ModalPortalRefContext = /*#__PURE__*/React.createContext();
var ModalPortalProvider = function ModalPortalProvider(_ref) {
  var children = _ref.children;
  var ref = useRefForContext();
  return /*#__PURE__*/React.createElement(ModalPortalRefContext.Provider, {
    value: ref
  }, children(ref));
};
process.env.NODE_ENV !== "production" ? ModalPortalProvider.propTypes = {
  children: PropTypes.func
} : void 0;

/**
 * Renders its children inside of the modal container created by `LayoutRoot`
 */
var ModalPortal = function ModalPortal(_ref2) {
  var children = _ref2.children;
  var ref = React.useContext(ModalPortalRefContext);

  // If layout is not preset, just render modal
  if (!ref) {
    return children;
  }

  // Layout is present but portal container hasn't mounted yet
  if (!ref.current) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/ReactDOM.createPortal(children, ref.current));
};
ModalPortal.propTypes = {
  children: PropTypes.node
};
export { ModalPortalProvider, ModalPortal };